import { odata } from '../../conf';
import Actions from '../../odata/actions';

const actions = new Actions('vehicleInspection', 'vehicleInspections');

const customActions = {
  async LOAD_vehicleInspections({ commit, rootGetters }) {
    const data = await odata.o(rootGetters)
      .get('vehicleInspections')
      .query({
        $filter: 'IsDeleted eq false',
        $expand: 'Vehicle',
      });
    commit('SET_vehicleInspections', data);
    return data;
  },
};

export default { ...actions, ...customActions };
